var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2887",
    "data-name": "Rectangle 2887",
    width: 16.944,
    height: 56.672,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5943",
    "data-name": "Path 5943",
    d: "M75.12,105h0a26.957,26.957,0,0,1,26.572,26.957v54.969h79.716V131.957A26.957,26.957,0,0,0,154.451,105Z",
    transform: "translate(-75.12 -105)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5947",
    "data-name": "Path 5947",
    d: "M118.58,75.53l31.648,9.112V67.35Z",
    transform: "translate(-118.58 -67.35)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-email"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 195
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    clipPath: "url(#clip-email)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email-2",
    "data-name": "email",
    transform: "translate(13 -41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13643",
    "data-name": "Group 13643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5936",
    "data-name": "Path 5936",
    d: "M119.935,110.77H55.154A28.074,28.074,0,0,0,28.9,128.993H7.586a.963.963,0,0,0-.339.1H7.2a1.071,1.071,0,0,0-.285.239h0a1.109,1.109,0,0,0-.177.323.493.493,0,0,1,0,.054,1.048,1.048,0,0,0-.039.277v56.456a1.117,1.117,0,0,0,.085.385h0a.963.963,0,0,0,.239.339h0a1.07,1.07,0,0,0,.331.216h0a1.163,1.163,0,0,0,.37.069H27.134v6.216a1.071,1.071,0,0,0,1.071,1.071h62.44v55.609a1.063,1.063,0,0,0,1.063,1.063h16.944a1.063,1.063,0,0,0,1.071-1.063V194.738H161.8a1.071,1.071,0,0,0,1.071-1.071V138.8a28.059,28.059,0,0,0-28.028-28.028h-12.77",
    transform: "translate(-1.54 -25.455)",
    fill: "#055261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5937",
    "data-name": "Path 5937",
    d: "M150.659,91.653v-18.4a.977.977,0,0,0,0-.216.186.186,0,0,1,0-.062,1.034,1.034,0,0,0-.054-.139v-.069a1,1,0,0,0-.077-.116l-.046-.062-.1-.1h0a.771.771,0,0,0-.131-.077H150.2c-.116-.054-3.474-.085-3.62-.085H146.5a.531.531,0,0,0-.154,0h0L116.77,79.961a1,1,0,0,0-.054,1.933l28.69,8.341",
    transform: "translate(-26.656 -16.62)",
    fill: "#055261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5938",
    "data-name": "Path 5938",
    d: "M93.584,186.957H39.67v-55a26.957,26.957,0,1,1,53.914,0Z",
    transform: "translate(-9.116 -24.129)",
    fill: "#f26939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5939",
    "data-name": "Path 5939",
    d: "M93.584,186.957H39.67v-55a26.957,26.957,0,1,1,53.914,0Z",
    transform: "translate(-9.116 -24.129)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2882",
    "data-name": "Rectangle 2882",
    width: 16.944,
    height: 56.672,
    transform: "translate(94.065 162.836)",
    fill: "#a66b45"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2883",
    "data-name": "Rectangle 2883",
    width: 16.944,
    height: 56.672,
    transform: "translate(94.065 162.836)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2884",
    "data-name": "Rectangle 2884",
    width: 78.33,
    height: 56.417,
    transform: "translate(10.082 99.125)",
    fill: "#f0eb4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2885",
    "data-name": "Rectangle 2885",
    width: 78.33,
    height: 56.417,
    transform: "translate(10.082 99.125)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13224",
    "data-name": "Group 13224",
    transform: "translate(94.065 162.829)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1024",
    "data-name": "Line 1024",
    x1: 26.926,
    y2: 31.008,
    transform: "translate(-2.241 -19.394)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1025",
    "data-name": "Line 1025",
    x1: 26.926,
    y2: 31.008,
    transform: "translate(-2.649 -12.108)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1026",
    "data-name": "Line 1026",
    x1: 26.926,
    y2: 31.016,
    transform: "translate(-3.058 -4.821)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1027",
    "data-name": "Line 1027",
    x1: 26.926,
    y2: 31.016,
    transform: "translate(-3.466 2.465)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1028",
    "data-name": "Line 1028",
    x1: 26.926,
    y2: 31.016,
    transform: "translate(-3.874 9.751)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1029",
    "data-name": "Line 1029",
    x1: 26.926,
    y2: 31.016,
    transform: "translate(-4.282 17.037)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1030",
    "data-name": "Line 1030",
    x1: 26.926,
    y2: 31.008,
    transform: "translate(-4.66 23.799)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1031",
    "data-name": "Line 1031",
    x1: 26.926,
    y2: 31.008,
    transform: "translate(-5.068 31.085)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1032",
    "data-name": "Line 1032",
    x1: 26.926,
    y2: 31.008,
    transform: "translate(-5.476 38.372)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1033",
    "data-name": "Line 1033",
    x1: 26.926,
    y2: 31.008,
    transform: "translate(-5.884 45.658)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13641",
    "data-name": "Group 13641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5940",
    "data-name": "Path 5940",
    d: "M13.09,128.7l39.157,32.064L91.412,128.7",
    transform: "translate(-3.008 -29.575)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1034",
    "data-name": "Line 1034",
    x1: 29.868,
    y2: 31.062,
    transform: "translate(10.074 124.488)",
    fill: "#f0eb4d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1035",
    "data-name": "Line 1035",
    x1: 29.868,
    y2: 31.062,
    transform: "translate(10.074 124.488)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1036",
    "data-name": "Line 1036",
    x2: 29.861,
    y2: 31.062,
    transform: "translate(58.543 124.488)",
    fill: "#f0eb4d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1037",
    "data-name": "Line 1037",
    x2: 29.861,
    y2: 31.062,
    transform: "translate(58.543 124.488)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5941",
    "data-name": "Path 5941",
    d: "M154.451,105H75.12a26.957,26.957,0,0,1,26.572,26.957v54.977h79.716V131.957A26.957,26.957,0,0,0,154.451,105",
    transform: "translate(-17.262 -24.129)",
    fill: "#5ce5ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13226",
    "data-name": "Group 13226",
    transform: "translate(57.858 80.871)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5942",
    "data-name": "Path 5942",
    d: "M60.228,1.39c3.643,3.551-3.5,10.9.162,14.426s10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.418-.323-3.5,10.906.146,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.146,14.434,10.783-3.851,14.418-.323-3.5,10.906.146,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.434-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316M51.918,13.929c3.643,3.528-3.5,10.9.146,14.426S62.847,24.5,66.49,28.039s-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.146,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.146,14.434,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.434,10.783-3.851,14.426-.316M41.767,25.212c3.643,3.528-3.5,10.9.146,14.426s10.783-3.851,14.426-.316-3.5,10.9.139,14.426S67.26,49.9,70.9,53.433s-3.5,10.9.139,14.426,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.146,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.146,14.434,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.434,10.783-3.851,14.426-.323m-199.7-91.3c3.643,3.528-3.535,10.9.139,14.4s10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.323-3.5,10.906.146,14.434,10.783-3.851,14.418-.323-3.5,10.906.146,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.434,10.783-3.851,14.426-.316M10.581,76.57C14.224,80.1,7.077,87.476,10.72,91S21.5,87.144,25.146,90.68s-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.418-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316-3.5,10.906.139,14.434,10.783-3.851,14.434-.316M18.853,64.061c3.643,3.528-3.5,10.906.139,14.434s10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.906.146,14.434,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.434-.316M27.125,51.538c3.643,3.528-3.5,10.9.139,14.426s10.783-3.851,14.426-.316-3.5,10.921.139,14.426,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.146,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.323-3.5,10.906.146,14.434,10.783-3.851,14.426-.323-3.5,10.906.139,14.434,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.434,10.783-3.851,14.434-.324M35.4,39.007c3.635,3.528-3.5,10.9.139,14.457s10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.426-.316-3.5,10.9.146,14.426,10.783-3.851,14.426-.316-3.5,10.9.139,14.426,10.783-3.851,14.434-.316-3.5,10.906.139,14.434,10.783-3.851,14.426-.316",
    transform: "translate(-58.172 -81.191)",
    fill: "none",
    stroke: "#055261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13642",
    "data-name": "Group 13642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5944",
    "data-name": "Path 5944",
    d: "M118.58,75.53l31.648,9.119V67.35Z",
    transform: "translate(-27.249 -15.477)",
    fill: "#f26939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5945",
    "data-name": "Path 5945",
    d: "M118.58,75.53l31.648,9.119V67.35Z",
    transform: "translate(-27.249 -15.477)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13228",
    "data-name": "Group 13228",
    transform: "translate(91.331 51.873)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5946",
    "data-name": "Path 5946",
    d: "M132.784,91.116a1.286,1.286,0,1,1-1.476.937,1.286,1.286,0,0,1,1.476-.937ZM130,87.742a1.769,1.769,0,1,0,.008,0Zm-2.78-3.381a1.759,1.759,0,1,0,.008,0Zm-2.773-3.381a1.279,1.279,0,1,1-1.54.909A1.279,1.279,0,0,1,124.442,80.98Zm-2.788-3.373a1.035,1.035,0,1,0,0,.008Zm6.932,13.717a3.1,3.1,0,1,1-.031.008ZM125.8,87.942a3.067,3.067,0,1,1-.031.008Zm-2.78-3.373a3.091,3.091,0,1,1-.031.008Zm-2.78-3.381a3.063,3.063,0,1,1-.031.008Zm18.315,6.578a3.094,3.094,0,1,1-.031.008Zm-2.78-3.381a1.286,1.286,0,1,1-1.476.937A1.286,1.286,0,0,1,135.772,84.384Zm-2.788-3.373a1.279,1.279,0,1,1-1.54.909,1.263,1.263,0,0,1,1.51-.9Zm-2.78-3.381a3.06,3.06,0,1,1-.031.008Zm-2.811-3.366a1.279,1.279,0,1,1-1.54.909A1.279,1.279,0,0,1,127.392,74.264ZM124.6,70.882a1.282,1.282,0,1,1-1.564.917A1.282,1.282,0,0,1,124.6,70.882Zm9.72,17.1a1.279,1.279,0,1,1-1.54.909A1.279,1.279,0,0,1,134.324,87.981Zm-2.78-3.381a1.72,1.72,0,1,1-.039,0Zm-2.788-3.373a1.721,1.721,0,1,1-.039,0Zm-2.78-3.373a1.279,1.279,0,1,1-1.265.316A1.279,1.279,0,0,1,125.975,77.853Zm-2.78-3.381a1.72,1.72,0,1,1-.039,0ZM120.407,71.1a1.727,1.727,0,1,1-.039,0Zm23.876,13.325a1.734,1.734,0,1,1-.031,0Zm-2.78-3.381a1.726,1.726,0,1,1-.031,0Zm-2.78-3.373a1.727,1.727,0,1,1-.031,0Zm-2.788-3.373a1.279,1.279,0,1,1-1.54.909,1.263,1.263,0,0,1,1.51-.909Zm-2.78-3.381a1.726,1.726,0,1,1-.031,0Zm-2.78-3.373a1.733,1.733,0,1,1-.031,0Zm9.674,17.091a1.726,1.726,0,1,1-.031,0Zm-2.78-3.373a1.733,1.733,0,1,1-.031,0ZM134.455,77.9a1.286,1.286,0,1,1-1.54.917,1.286,1.286,0,0,1,1.54-.917Zm-2.788-3.373a1.046,1.046,0,1,1,0-.023Zm-2.78-3.381a1.05,1.05,0,1,1,0-.023Zm-2.78-3.373a1.279,1.279,0,1,1-.655,2.472,1.263,1.263,0,0,1-.909-1.54,1.279,1.279,0,0,1,1.564-.955ZM149.982,81.1a1.286,1.286,0,1,1-1.476.937,1.286,1.286,0,0,1,1.476-.937Zm-2.788-3.373a1.376,1.376,0,1,1,.008-.023Zm-2.78-3.381a1.385,1.385,0,1,1,.008-.023Zm-2.773-3.373a1.279,1.279,0,1,1-1.54.909,1.279,1.279,0,0,1,1.54-.909Zm-2.788-3.373a1.046,1.046,0,1,1,0-.023Zm-2.78-3.381a1.05,1.05,0,1,1,0-.023Zm9.681,17.1a1.045,1.045,0,1,1,0-.023ZM142.966,77.9a1.279,1.279,0,1,1-1.54.917A1.279,1.279,0,0,1,142.966,77.9Zm-2.78-3.373a1.036,1.036,0,1,0,0,.008Zm-2.78-3.373a1.286,1.286,0,1,1-1.54.917,1.286,1.286,0,0,1,1.54-.917Zm-2.788-3.373a1.279,1.279,0,1,1-1.54.909A1.279,1.279,0,0,1,134.617,67.779Zm-2.78-3.381a1.286,1.286,0,1,1-1.54.917A1.286,1.286,0,0,1,131.836,64.4ZM155.713,77.73a1.766,1.766,0,1,0,.008,0Zm-2.78-3.381a1.756,1.756,0,1,0,.008,0Zm-2.78-3.381a1.279,1.279,0,1,1-1.54.909,1.263,1.263,0,0,1,1.54-.909Zm-2.78-3.381a1.042,1.042,0,1,0,0,.008Zm-2.78-3.373a1.036,1.036,0,1,0,0,.008Zm6.893,13.717a1.036,1.036,0,1,0,0,.008Zm-2.78-3.381a1.286,1.286,0,1,1-1.476.937A1.286,1.286,0,0,1,148.7,74.549Zm-2.788-3.373a1.036,1.036,0,1,0,0,.008Zm-2.78-3.373a1.279,1.279,0,1,1-1.265.316,1.279,1.279,0,0,1,1.265-.316Zm-2.78-3.381a1.041,1.041,0,1,0,0,.008Zm15.535,3.2a1.279,1.279,0,1,1-1.54.909,1.279,1.279,0,0,1,1.54-.909ZM153.1,64.251a1.279,1.279,0,1,1-1.54.909,1.279,1.279,0,0,1,1.54-.909Zm4.113,10.336a1.279,1.279,0,1,1-1.54.917,1.279,1.279,0,0,1,1.54-.917Zm-2.78-3.373a1.279,1.279,0,1,1-1.54.909,1.279,1.279,0,0,1,1.54-.909Zm-2.78-3.381a1.286,1.286,0,1,1-1.54.917,1.286,1.286,0,0,1,1.54-.917Zm-2.788-3.373a1.279,1.279,0,1,1-1.54.909A1.279,1.279,0,0,1,148.866,64.459Z",
    transform: "translate(-118.597 -66.616)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.77
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13640",
    "data-name": "Group 13640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5948",
    "data-name": "Path 5948",
    d: "M165.623,145.4a8.726,8.726,0,1,1-8.726-8.726,8.726,8.726,0,0,1,8.726,8.726",
    transform: "translate(-34.049 -31.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5949",
    "data-name": "Path 5949",
    d: "M165.623,145.4a8.726,8.726,0,1,1-8.726-8.726A8.726,8.726,0,0,1,165.623,145.4Z",
    transform: "translate(-34.049 -31.406)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5950",
    "data-name": "Path 5950",
    d: "M156.67,147.35a2.18,2.18,0,1,0,2.18-2.18,2.18,2.18,0,0,0-2.18,2.18",
    transform: "translate(-36.002 -33.36)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1038",
    "data-name": "Line 1038",
    y2: 62.479,
    transform: "translate(122.978 51.873)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5951",
    "data-name": "Path 5951",
    d: "M154.451,105H75.12a26.957,26.957,0,0,1,26.572,26.957v54.977h79.716V131.957A26.957,26.957,0,0,0,154.451,105Z",
    transform: "translate(-17.262 -24.129)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ced377183b8d41bef61e49ecbf9c50f3.svg";
export { ForwardRef as ReactComponent };